import { MaxLrHandler } from "./MaxLrHandler";
import { MaxLrAicHandler } from "./MaxLrAicHandler";
import { NonContributorAnalysisHandler } from "./NonContributorAnalysisHandler";
import { DnaMatchHandler } from "./DnaMatchHandler";
import { CaseRunCreateModelBase } from "@app/api2/api";
import { DeconvMainHandler } from "./DeconvMainHandler";
import { BrutusHandler } from "./Brutus/BrutusHandler";
import { FamilialSearchHandler } from "./FamilialSearch/FamilialSearchHandler";
import { IntegralHandler } from "./Bayesian/IntegralHandler";
import { GenerateSampleHandler } from "./GenerateSample/GenerateSampleHandler";
import { ICreateRenderer } from "../CaseRunCreate";

export class HandlerRegistry {
    private static runTypeHandlers = [
        new MaxLrHandler(), new MaxLrAicHandler(), new NonContributorAnalysisHandler(),
        new DnaMatchHandler(), new DeconvMainHandler(), new BrutusHandler(), new FamilialSearchHandler(),
        new IntegralHandler(), new GenerateSampleHandler()
    ];

    static hasOwnRunList(runType: string) {
        var handler = HandlerRegistry.getRunTypeHandler(runType) as ICreateRenderer<any, any>;
        if (handler && handler.hasOwnRunList)
            return handler.hasOwnRunList();
        else 
            return true;
    }

    static getRunTypeHandler(runType: string) {
        return this.runTypeHandlers.find(handler => handler.canHandle(runType));
    }


    static renderResults(runType: string, props: { labId, caseId, caseRunId }) {
        var handler = this.getRunTypeHandler(runType)
        if ('renderResults' in handler)
            return handler.renderResults(props)

        return null
    }

    static renderRunList(runType: string, props: { canCreateEvidence: boolean, labId: number, caseId: number, referenceId?: number }) {
        var handler = this.getRunTypeHandler(runType)
        if ('renderRunList' in handler)
            return handler.renderRunList(props)

        return null
    }
}